import api from "./api";

const getBuyers = async () => {

    const response = await api.get("/api/buyers");

    return response.data.data;

};

const addBuyer = async(formData)=>{
    const response = await api.post(
        "/api/buyer",
        formData
    );

    return response.data;

}

const updateBuyer = async(id,formData)=>{

    const response = await api.put(
        `/api/buyers/${id}`,
        formData
    );

    return response.data;

}

const deleteBuyer = async(id)=>{

    const response = await api.delete(`/api/buyers/${id}`);

    return response.data;

}

export default{
    getBuyers,
    addBuyer,
    updateBuyer,
    deleteBuyer
}